import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";

export const courseByHeadofficeCourseId = createAsyncThunk(
    'courseByHeadofficeCourseId',
    async ({ userId, headofficeCourseId, instituteId, navigate }) => {
        try {
            const res = await axios({
                method: 'GET',
                url: getConfig.API_URL + 'course_by_headoffice_course_id',
                params: {
                    user_id: userId,
                    headoffice_course_id: headofficeCourseId,
                    institute_id: instituteId,
                },
                headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
            })
            return res
        } catch (error) {
            return error.response
        }
    }
)

const courseByHeadofficeCourseIdSlice = createSlice({
    name: 'courseByHeadofficeCourseId',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(courseByHeadofficeCourseId.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = (() => { const raw = action.payload.data.data; return Array.isArray(raw) ? raw : (Object.values(raw || {}).find(Array.isArray) || []); })();
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(courseByHeadofficeCourseId.rejected, (state) => {
            state.data = []
        })
    }
})

export default courseByHeadofficeCourseIdSlice.reducer;
